import moment from "moment";
import { videoUrlDoctorManagement } from "../../DoctorMangement/constant";
import { SPOC_VIDEO_URL } from "../../SPOC/constant";
import { otpEnabledAttendanceProvider } from "../../../auth/common";

export const actionTextActionMap = {
    "Confirm": "Confirm",
    "Cancel": "Cancel",
    "Reschedule": "Reschedule",
    "RejectedByProvider": "Reject",
    "Attended": "Attended",
    "NotAttended": "NotAttended",
    "Prescription Verification Pending": "Upload Rx",
    "ReportApprovalPendingByBranch": "Upload Documents",
    "Submit": "Upload Documents",
}

export const allowedActions = ["Confirm", "Reschedule", "RejectedByProvider", "Attended", "NotAttended","Prescription Verification Pending"]

export const priorityNames = {
    0: "NONE",
    1: "URGENT",
    2: "HNI",
    3: "SHNI",
    4: "SHNI",
    5: "URGENT,SHNI",
    6: "HNI,SHNI",
    7: "URGENT,HNI,SHNI"
}

export const dateFilters = [
    { name: "Today", startDate: moment().format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD") },
    {
      name: "Previous 7 Days",
      startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    { name: "Next 7 Days", startDate: moment().format("YYYY-MM-DD"), endDate: moment().add(7, "days").format("YYYY-MM-DD") },
    {
      name: "Previous 15 Days",
      startDate: moment().subtract(15, "days").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    { name: "Next 15 Days", startDate: moment().format("YYYY-MM-DD"), endDate: moment().add(15, "days").format("YYYY-MM-DD") },
    { name: "Next 30 Days", startDate: moment().format("YYYY-MM-DD"), endDate: moment().add(30, "days").format("YYYY-MM-DD") },
    { name: "Rolling 1 Month", startDate: moment().subtract(15, "days").format("YYYY-MM-DD"), endDate: moment().add(15, "days").format("YYYY-MM-DD") },
    { name: "Custom" },
  ];

  export const dateFiltersVision = [
    { name: "Today", startDate: moment().format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD") },
    {
      name: "Previous 7 Days",
      startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    {
      name: "Previous 15 Days",
      startDate: moment().subtract(15, "days").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    { name: "Custom" },
  ];

  export const feedBackList = ["Satisfied", "Dissatisfied", "Pacifistic"];

  export const rescheduleReasons = ["Doctor is on leave","Doctor in OT","Slots not available","Patient wants to reschedule","OPD is closed","Doctor in rounds","Others"];
  export const notAttendedReasons = ["Personal reason, change in plan","Personal reason, want to re-schedule","Doctor not available","Provider collected money","Provider did not provide service"];
  export const rejectReasons = ["Doctor is on leave / emergency leave.","Doctor is no longer working at the hospital.","Patient is not happy with the alternative doctor.","Patient doesn't want to reschedule.","Unable to reschedule (already done twice)","Doctor fee is incorrect.","User doesn't want to consult anymore.", "Others"];

  export const offlineConsultsTabs = [
    { id: 1, name: "All Appointments", route: "/offlineConsults/allAppointments" },
    { id: 2, name: "New Appointments", route: "/offlineConsults/upcoming" },
    { id: 3, name: "Confirmed Appointments", route: "/offlineConsults/confirmed" },
    { id: 4, name: "Documents", route: "/offlineConsults/documentUpload" },
    { id: 5, name: "Cancelled Appointment", route: "/offlineConsults/cancelled" },
  ];

  export const offlineConsultsContract = 10401;

  export const serviceMap = {
    "LABS": "Labs",
    "OFFLINE_CONSULTS": "In-Clinic Consultation",
    "VISION": "Vision"
  }

export const languagesMaps = () => {
  return {
    "English": otpEnabledAttendanceProvider() ? "https://views.medibuddy.in/Provider-Central-english-v2.mp4" : "https://views.medibuddy.in/provider-central-english.mp4",
    // "Hindi": "https://drive.google.com/file/d/1FITq7LHU_kHoTOflA7cOZwB8E3mdc5yt/preview",
    // "Kannada": "https://drive.google.com/file/d/1FITq7LHU_kHoTOflA7cOZwB8E3mdc5yt/preview", 
    // "Tamil": "https://drive.google.com/file/d/1FITq7LHU_kHoTOflA7cOZwB8E3mdc5yt/preview",
    // "Telugu" : "https://drive.google.com/file/d/1FITq7LHU_kHoTOflA7cOZwB8E3mdc5yt/preview"
  }
};

export const How_To_Use_Video_Maps = () => {
  return {
    "OMS": {
      videoUrl: otpEnabledAttendanceProvider() ? "https://views.medibuddy.in/Provider-Central-english-v2.mp4" : "https://views.medibuddy.in/provider-central-english.mp4",
      name: "Provider Central"
    },
    "DMS": {
      videoUrl: videoUrlDoctorManagement,
      name: "Doctor Management"
    },
    "SPOC":
    {
      videoUrl: SPOC_VIDEO_URL,
      name: "SPOC Management"
    },
  }
}

  export const platform = "providerCentral"

  export const slaFilters = ["Priority Cases", "Total Cases"];

  export const CONFIRM = "Confirm"

  export const ATTENDED = "Attended"

  export const OFFLINE_CONSULTS = "OFFLINE_CONSULTS"
  export const LABS = "LABS"
  export const APPOINTMENT ="appointment";

  export const SURGERY_BOOKING_SOURCE = 'Surgery_Retool_OPD_Booking';
  export const SURGERY_DISPLAY_NAME = 'Surgery';